import React, { useContext, useEffect, useRef, useState } from "react";
import { SLogo, SSidebar, SSidebarButton, SSidebarButtonLogout, ResponsiveImage } from "./styles";
import { AiOutlineLeft, AiOutlineLogout } from "react-icons/ai"
import { ThemeContext } from "../../../App";
import SubMenu from "./subMenu";
import axios from "axios";

import empresasData from "../../../lib/json/empresas.json"
import menu from '../../../lib/json/menu.json'
import { retornaPerfil } from "../../contents/VariaveisGlobais";


function Sidebar({onLogout, sidebarOnChange}){
	const { setTheme, theme } = useContext(ThemeContext);
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const [menuPrincipal, setMenuPrincipal] = useState(false);
	
	const empresaFilial = localStorage.getItem('empresaFilial');
	const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
	const empresaLogado = empresasData.empresas.find((empresa) => empresa.empresaFilial === empresaFilial);
	
	var dadosPerfil = null;
  
	useEffect( () => {
		const fecthLoadSystem = async() =>{
      let menuSistema = menu;
			
      if (usuarioLogado.usuario !== 'ADMIN'){
				menuSistema = JSON.parse(usuarioLogado.menu);
			}

			setMenuPrincipal(menuSistema)
		}

		fecthLoadSystem()
	}, [])
	

    const toggleBarMenu = () => {
		setSidebarOpen((prev) => !prev);
		sidebarOnChange((prev) => !prev);
		// VariaveisGlobais(!sidebarOpen);
    };
  
    const handleLogout = () => {
		onLogout();
    };
  
    return (
      <SSidebar data-isopen={sidebarOpen} id="SSidebar">
        <div>
            <SSidebarButton data-isopen={sidebarOpen} onClick={toggleBarMenu}>
                <AiOutlineLeft />
            </SSidebarButton>

            <SLogo>
                <ResponsiveImage data-isopen={sidebarOpen} src={`${process.env.PUBLIC_URL}/${theme === 'dark' ? empresaLogado.logoEmpresaDark : empresaLogado.logoEmpresa}`} alt="logo" />
            </SLogo>

            <SSidebarButtonLogout data-isopen={sidebarOpen} onClick={handleLogout}>
                <AiOutlineLogout />
            </SSidebarButtonLogout>
        </div>
        <></>
        { menuPrincipal &&
            menuPrincipal.map((item, index) => {
                return <SubMenu item={item} key={index} baropen={sidebarOpen} notification={item.notification} />;
            })
        }
      </SSidebar>
    );
}

export default Sidebar;